class Notification {
    constructor() {
        this.tracks = new Map();
    }

    play(track_name, silent = false) {
        window.AudioContext = window.AudioContext || window.webkitAudioContext;
        const context = new AudioContext();
        let source = null;

        function playSound(buffer2play) {
            // creates a sound source
            source = context.createBufferSource();

            // tell the source which sound to play
            source.buffer = buffer2play;

            source.loop = false;

            // connect the source to the context's destination (the speakers)
            source.connect(context.destination);
            
            // Create a gain node and Connect the source to the gain node
            const gainNode = context.createGain();
            source.connect(gainNode);

            // Connect the gain node to the destination
            gainNode.connect(context.destination);

            // Set the volume
            const volume = 1
            gainNode.gain.value = volume;

            if(typeof source.noteOn === 'function') {
                source.noteOn(0) // play source now, using noteOn
            } else {
                source.start(0); // play the source at the deisred time 0=now
            }  
        }
            
        function initSound(arrayBuffer) {
            context.decodeAudioData(arrayBuffer, function(buffer) {
                if(!silent) playSound(buffer);
            }, function(err) {
                console.log('Error decoding file', err);
            }); 
        }
        
        // Load file from a URL as an ArrayBuffer.
        // Example: loading via xhr: loadSound('sounds/test.mp3');
        function loadSound(url) {
            const request = new XMLHttpRequest();

            // fetch the sound file
            request.open('GET', url, true);
            request.responseType = 'arraybuffer';

            request.onload = function() {
                // Decode asynchronously
                initSound(this.response); // this.response is an ArrayBuffer.
            };
            request.send();
        }

        function unlock (context) {
            const buffer = context.createBuffer(1, 1, 22050);
            const source = context.createBufferSource();
            source.buffer = buffer;
            source.connect(context.destination);
    
            // play the file. noteOn is the older version of start()
            source.start ? source.start(0) : source.noteOn(0);
        }

        if(this.tracks.has(track_name)) {
            unlock(context) // to work on Some IOS devices specially
            loadSound(this.tracks.get(track_name))
        }
    }

    add(name, src) {
        if(!name.trim() || !src.trim()) return;
        if (!this.tracks.has(name)) {
            this.tracks.set(name, src);
            this.play(name, true) // predownload the sound file while adding in this service to prevent from downloading when message trigger
        }
    }
}

export default new Notification();
